import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'app-drawer',
    templateUrl: './drawer.component.html',
    styleUrls: ['./drawer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrawerComponent implements OnChanges {
    @ViewChild('drawer') public drawer: any;

    @Input() showFilterButtons = true;
    @Input() showToggleButton = true;
    @Input() title = 'FILTERS';
    @Input() toggle = false;

    @Output() public searchFilter = new EventEmitter<any>();
    @Output() public clearFilter = new EventEmitter<any>();
    @Output() public setDrawerState = new EventEmitter<any>();

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (this.drawer && changes.toggle) {
            this.toggleDrawer();
        }
    }

    toggleDrawer() {
        this.drawer.toggle();
        this.setDrawerState.emit(this.drawer.expanded);
    }
}
